import React from 'react';
import classnames from 'classnames';
import { translate } from '@fiverr-private/i18n-react';
import { getTranslatedSubCategoryName } from '../../../../lib/catalog/getTranslatedSubCategoryName';
import { COPIES_PREFIX } from '../constants';
import type { FeaturedSubCategoryProps } from './types';

import classes from './FeaturedSubCategory.module.scss';

export const FeaturedSubCategory = ({ id }: FeaturedSubCategoryProps) => {
  const textFeaturedIn = translate(`${COPIES_PREFIX}.featured_in`);
  const textSubCategoryName = getTranslatedSubCategoryName(id);
  return (
    <div className={classnames(classes.container, 'm-l-24 m-r-24 m-t-12 m-b-16')}>
      <p className="co-text-darker">{textFeaturedIn}</p>
      <h4 className="co-text-darkest">{textSubCategoryName}</h4>
    </div>
  );
};
